/* Custom Scrollbar in Cart */

// (function($){
//   $(window).on("load",function(){
//     $(".cart-drawer-inner").mCustomScrollbar({
//       theme:"dark",
//     });
//   });
// })(jQuery);

 (function($){
    $(window).resize(function() {
      if($(this).width()>768){
        $(".cart-drawer-inner, .guest").mCustomScrollbar({
        theme: "dark"
    }); 
      } else {
        $(".cart-drawer-inner, .guest").mCustomScrollbar("destroy"); 
      }
    }).trigger("resize");
  })(jQuery);

/* Scroll to Top */

$(window).scroll(function() {
  if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
    $('.scroll-to-top-wrap').fadeIn(200);    // Fade in the arrow
  } else {
    $('.scroll-to-top-wrap').fadeOut(200);   // Else fade out the arrow
  }
});
$('.scroll-to-top-wrap').click(function() {      // When arrow is clicked
  $('body,html').animate({
    scrollTop : 0                       // Scroll to top of body
  }, 500);
});


/* Sticky Header */
$(window).scroll(function(){
  if ($(window).scrollTop() >= 114) {
    $('.site-header').addClass('fixed-header');
    $('body').addClass('body-fixed-header');
  }
  else {
    $('.site-header').removeClass('fixed-header');
    $('body').removeClass('body-fixed-header');
  }
});


$( document ).ready(function() {
  
  $('#main_footer .mega-menu-wrap').html($('.site-header .mega-menu-wrap').html());
  
  if($(window).width() >= 1280 && $(window).height() <= 799) {
    var header_height = $(window).height() - 30; 
    $('.site-nav .mega-menu-wrap').height(header_height);
    $(".site-nav li.delivery-takout").hover(
      function () {
        $(this).addClass("result_hover");
        $('body').addClass("stop-scroll");
      },
      function () {
        $(this).removeClass("result_hover");
        $('body').removeClass("stop-scroll");
      }
    );
  }

  /* Set Height of Megamenu and Cart */ 

  if($(window).width() < 1280) {
    var mobilenav = $(window).height() - 109;
    $('.mobile-nav-wrapper').height(mobilenav); 
    var cartdrawer = $(window).height() - 365;
    $('.cart-drawer-main-wrap .cart-drawer-body').height(cartdrawer);
    $('#MobileNav .site-header__search-toggle').click(function(){
      $('.site-header__mobile-nav .site-header__search-toggle').click();
    });
  }

  /*   Custom JS     */

  var temp = 0;
  $('.grid .grid__item.grid__item--collection-template').each(function(){
    temp++;
    $(this).attr("id","grid"+temp);
    if(temp == 3){
      temp = 0;			
    }
  });

  /*   SideCart   */  

  $('.site-header__cart').on('click', function(){
    $('.cart-drawer-main-wrap').toggleClass('open-cart');
    $('.cart-drawer-main-wrap').parent().toggleClass('open-cart');
    $('body').toggleClass('open-cart');
  });
  $('.cart-drawer-overlay, .close-link').on('click', function(event){
    if ( $(event.target).hasClass('cart-drawer-overlay') || $(event.target).hasClass('close-link') ) {
      $('.open-cart').removeClass('open-cart');
    }
  });

  /* Expand Grid View */

  $('.custom-grid-view-wrap .grid__item .edit-btn').click(function(){
    // change size of item by toggling gigante class
    $(this).parent().parent().parent().addClass('width-100').siblings().removeClass('width-100');
    $(this).parent().siblings('.product-card-content-wrap').hide().parent().parent().siblings().children().children('.product-card-content-wrap').show();
    $(this).parent().siblings('.list-bottom-content-wrap').slideDown().parent().parent().siblings().children().children('.list-bottom-content-wrap').slideUp();  
  });

  $('.custom-grid-view-wrap .grid__item .close-btn').click(function(){
    // change size of item by toggling gigante class
    $(this).parent().parent().parent().parent().removeClass('width-100');
    $(this).parent().parent().siblings('.product-card-content-wrap').show();
    $(this).parent().parent().siblings('.list-bottom-content-wrap').slideUp();  
  });

  $('.custom-product-card-list:not(.custom-product-card-grid) .list-view-buttons .edit-btn').click(function(e){
    $(this).parent().parent().parent().addClass('active-product-card-list').parent().siblings().children('.custom-product-card-list').removeClass('active-product-card-list');
    $(this).parent().parent().siblings('.list-bottom-content-wrap').slideDown().parent().parent().siblings().children().children('.list-bottom-content-wrap').slideUp();
  });

  $('.custom-product-card-list:not(.custom-product-card-grid) .list-view-buttons .close-btn').click(function(e){
    $(this).parent().parent().parent().removeClass('active-product-card-list');
    $(this).parent().parent().siblings('.list-bottom-content-wrap').slideUp();
  });
  
  $('.custom-card-button.info-btn').click(function(e){
    $(this).parent().parent().parent().addClass('active-custom-card').siblings().removeClass('active-custom-card');
    $(this).parent().parent().siblings().slideDown().parent().siblings().children('.custom-card-bottom').slideUp();
  });
  
  $('.custom-card-button.close-btn').click(function(e){
    $(this).parent().parent().parent().removeClass('active-custom-card');
    $(this).parent().parent().siblings().slideUp();
  });
  
  
  if($(window).width() < 750) {
    $('.custom-product-card-list:not(.custom-product-card-grid) .list-view-buttons .edit-btn').click(function(e){
      $(this).parent().siblings('.list-view-item-content-column').hide();
      $(this).parent().parent().parent().parent().siblings().children().children('.list-view-item__link').children('.list-view-item-content-column').show();
    });
    $('.custom-product-card-list:not(.custom-product-card-grid) .list-view-buttons .close-btn').click(function(e){
      $(this).parent().siblings('.list-view-item-content-column').show();
    });

    $('.custom-card-button.info-btn').click(function(e){
      $(this).parent().parent().children('.custom-card-content-wrap').hide();
      $(this).parent().parent().parent().siblings().children().children('.custom-card-content-wrap').show();
    });
    $('.custom-card-button.close-btn').click(function(e){
      $(this).parent().parent().children('.custom-card-content-wrap').show();
    });
  }
  
  $('.extra-drop-down-wrap .drop-title').click(function(e){
    $(this).siblings().slideToggle();
  });
  
  
	/* Custom Select Box */
  
  //TOGGLING NESTED ul
  
  $(".category-dropdown.custom-dropdown-wrap .selcted-dropdown a").click(function() {
    $(".category-dropdown.custom-dropdown-wrap .drop-down-content ul").slideToggle();
  });

  //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
  
  $(".category-dropdown.custom-dropdown-wrap .drop-down-content ul li a").click(function() {
    var text = $(this).html();
    $(this).parent().addClass('active-link').siblings().removeClass('active-link');
    $(".category-dropdown.custom-dropdown-wrap .selcted-dropdown a span.select-text").html(text);
    $(".category-dropdown.custom-dropdown-wrap .drop-down-content ul").hide();
  }); 

  //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
  
  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("category-dropdown"))
      $(".category-dropdown.custom-dropdown-wrap .drop-down-content ul").hide();
  });
  
  //TOGGLING NESTED ul
  
  $(".tag-dropdown.custom-dropdown-wrap .selcted-dropdown a").click(function() {
    $(".tag-dropdown.custom-dropdown-wrap .drop-down-content ul").slideToggle();
  });

  //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
  $(".tag-dropdown.custom-dropdown-wrap .drop-down-content ul li a").click(function() {
    var text = $(this).html();
    $(this).parent().addClass('active-link').siblings().removeClass('active-link');
    $(".tag-dropdown.custom-dropdown-wrap .selcted-dropdown a span.select-text").html(text);
    $(".tag-dropdown.custom-dropdown-wrap .drop-down-content ul").hide();
  }); 
  
  //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
  
  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("tag-dropdown"))
      $(".tag-dropdown.custom-dropdown-wrap .drop-down-content ul").hide();
  });
  
  	
  /* Display Grid or List View JS */
  
  $('.grid-view-icon').click(function(e){
  	$('.custom-collection-body-inner').addClass('display-grid').removeClass('display-list');
  });
  $('.list-view-icon').click(function(e){
  	$('.custom-collection-body-inner').addClass('display-list').removeClass('display-grid');
  });
  
  
  /* Custom Qty Box */
  
  $(".qty-wrap .plus").click(function(){
    var val= $(this).siblings('.qty').val();
    val++;
    if(val >= 0 && val <= 10){
      $(this).siblings('.qty').attr("value", val);
    }
  });
  $(".qty-wrap .minus").click(function(){
    var val= $(this).siblings('.qty').val();
    val--;
    if(val >= 0){
      $(this).siblings('.qty').attr("value", val);
    }
  });
 

  /*   Slider   */  

  $('.content-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.image-slider'
  });
  $('.image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.content-slider',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true    
  }); 
  
  /*   Mobile Menu Dropdown */

  $('.mobile-nav__item.drop-down-wrap').click(function(){
    $(this).children('.mega-menu-wrap').slideToggle();
    $(this).toggleClass('mobile_drop_down_open');
  });
  
});



$(window).on('resize', function() {
  
  if($(window).width() >= 1280 && $(window).height() <= 799) {
    var header_height = $(window).height() - 30; 
    $('.mega-menu-wrap').height(header_height);
    $(".site-nav li.delivery-takout").hover(
      function () {
        $(this).addClass("result_hover");
        $('body').addClass("stop-scroll");
      },
      function () {
        $(this).removeClass("result_hover");
        $('body').removeClass("stop-scroll");
      }
    );
  }
  
  /* Set Height of Megamenu and Cart */ 
  
  if($(window).width() < 1280) {
    var mobilenav = $(window).height() - 87;
    $('.mobile-nav-wrapper').height(mobilenav); 
    var cartdrawer = $(window).height() - 365;
    $('.cart-drawer-main-wrap .cart-drawer-body').height(cartdrawer);
    $('#MobileNav .site-header__search-toggle').click(function(){
      $('.site-header__mobile-nav .site-header__search-toggle').click();
    });
  }
  
  if($(window).width() < 750) {
    
    $('.custom-product-card-list:not(.custom-product-card-grid) .list-view-buttons .edit-btn').click(function(e){
      $(this).parent().siblings('.list-view-item-content-column').hide();
      $(this).parent().parent().parent().parent().siblings().children().children('.list-view-item__link').children('.list-view-item-content-column').show();
    });
    $('.custom-product-card-list:not(.custom-product-card-grid) .list-view-buttons .close-btn').click(function(e){
      $(this).parent().siblings('.list-view-item-content-column').show();
    });

    $('.custom-card-button.info-btn').click(function(e){
      $(this).parent().parent().children('.custom-card-content-wrap').hide();
      $(this).parent().parent().parent().siblings().children().children('.custom-card-content-wrap').show();
    });
    $('.custom-card-button.close-btn').click(function(e){
      $(this).parent().parent().children('.custom-card-content-wrap').show();
    });
  }
  
});


//=== Equl Height ===================================================
// PageInits = {
//   equlheight: function(a){
//     var top = 0;
//     var main = $(a);
//     var randomClass = ( 'eH' + Math.random() ).replace('.','');
//     main.each( function() {

//       var distanceFromTop = $(this).offset().top;

//       if ( distanceFromTop > top ) {
//         $('.' + randomClass).removeClass(randomClass);
//         top = distanceFromTop;
//       }

//       $(this).addClass(randomClass);

//       $(this).css('height','auto');

//       var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
//         return $(this).outerHeight();
//       }).get()));

//       $('.' + randomClass).css('height',newHeight);

//     }).removeClass(randomClass);

//   }
// }

// $( document ).ready(function() {
//   setTimeout(function(){ PageInits.equlheight('.today-special-products .custom-grid-view-wrap .grid__item'); }, 1500);
// });

// $(window).resize(function(){
//   setTimeout(function(){ PageInits.equlheight('.today-special-products .custom-grid-view-wrap .grid__item'); }, 1500);
// });


class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    this.content = el.querySelector('.content');

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
    // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;
    
    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 100,
      easing: 'ease-out'
    });
    
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 100,
      easing: 'ease-out'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('details').forEach((el) => {
  new Accordion(el);


});

